import { useEffect, useState } from 'react';
import { isNull } from 'lodash';
import { gtmCaptureRemoveFromCart } from 'api/gtm';
import ProductSubscriptionOnlyCard from 'components/common/cards/ProductSubscriptionOnlyCard';
import { useSubscriptions } from 'contexts/SubscriptionContext';
import { parseMaxQty } from 'helpers/parse';
import { useRecoilValue } from 'recoil';
import { formState } from 'state';

export default function ProductSubscriptionOnlyCardContainer({ data, subscribeText }) {
  const {
    countryInfo: { marketName, iso2: marketIso },
  } = useRecoilValue(formState);
  const { dispatch, hasSubscriptionInCart } = useSubscriptions();
  const [qty, setQty] = useState(0);

  const marketsUsingNewDesign = ['JP'];
  const isMarketUsingNewDesign = marketsUsingNewDesign.includes(marketIso);

  const {
    ProductID,
    SignupAutoshipOptionQtyOptions,
    SmallImageURL,
    DisplayName,
    Volume,
    Volume2,
    WholesalePrice,
    AutoShipPrice,
  } = data;
  const maxQty = parseMaxQty(SignupAutoshipOptionQtyOptions);

  useEffect(() => {
    const result = hasSubscriptionInCart(ProductID);

    if (result) {
      setQty(result.Quantity);
    }
  }, []);

  const decrement = () => {
    if (qty == 1) {
      const { pathname } = window.location;

      // Run only on this step.
      if (pathname === '/steps/starter-kit/select-product') {
        // GTM Analytics
        const variant = 'Subscription';
        gtmCaptureRemoveFromCart({ data, marketName, variant, pathname });
      }

      dispatch({
        type: 'removeSubscriptionFromCart',
        id: ProductID,
      });
    } else {
      dispatch({ type: 'decrementSubscription', id: ProductID });
    }
    setQty(qty - 1);
  };

  const increment = () => {
    if (qty == 0) {
      // Validate subscription does not already exist in cart.
      const result = hasSubscriptionInCart(ProductID);
      if (!result) {
        dispatch({
          type: 'addSubscriptionToCart',
          subscription: data,
          quantity: 1,
        });
      }
    } else {
      dispatch({ type: 'incrementSubscription', id: ProductID });
    }
    setQty(qty + 1);
  };

  const validateIncrement = () => {
    if (!isNull(maxQty)) {
      if (qty < maxQty) {
        increment();
      }
    } else {
      increment();
    }
  };

  return (
    <ProductSubscriptionOnlyCard
      useNewDesign={isMarketUsingNewDesign}
      AutoShipPrice={AutoShipPrice}
      subscribeText={subscribeText}
      imgSrc={SmallImageURL}
      imgAlt={DisplayName}
      title={DisplayName}
      cv={Volume}
      qv={Volume2}
      price={WholesalePrice}
      qty={qty}
      maxQty={maxQty}
      decrement={decrement}
      increment={validateIncrement}
    />
  );
}
